import { render, staticRenderFns } from "./forecastSetupDate.vue?vue&type=template&id=47dd839b&scoped=true"
import script from "./forecastSetupDate.vue?vue&type=script&lang=js"
export * from "./forecastSetupDate.vue?vue&type=script&lang=js"
import style0 from "./forecastSetupDate.vue?vue&type=style&index=0&id=47dd839b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd839b",
  null
  
)

export default component.exports